import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';

interface PasswordModalState {
  isLoading: boolean;
  isSentCodeNotificationShown: boolean;
}

const initialState: PasswordModalState = {
  isLoading: false,
  isSentCodeNotificationShown: true
};

export const PasswordModalStore = signalStore(
  withState(initialState),
  withMethods((store) => ({
    updateIsLoading: (isLoading: boolean) => {
      patchState(store, { isLoading });
    },
    updateIsSentCodeNotificationShown: (isSentCodeNotificationShown: boolean) => {
      patchState(store, { isSentCodeNotificationShown });
    }
  }))
);
